/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewProcess } from './CRSFSecReviewProcess';
import {
    CRSFSecReviewProcessFromJSON,
    CRSFSecReviewProcessFromJSONTyped,
    CRSFSecReviewProcessToJSON,
} from './CRSFSecReviewProcess';

/**
 * 
 * @export
 * @interface CRSFSecReviewProcessPagedResponse
 */
export interface CRSFSecReviewProcessPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewProcessPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewProcessPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFSecReviewProcess>}
     * @memberof CRSFSecReviewProcessPagedResponse
     */
    results?: Array<CRSFSecReviewProcess>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewProcessPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFSecReviewProcessPagedResponse interface.
 */
export function instanceOfCRSFSecReviewProcessPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFSecReviewProcessPagedResponseFromJSON(json: any): CRSFSecReviewProcessPagedResponse {
    return CRSFSecReviewProcessPagedResponseFromJSONTyped(json, false);
}

export function CRSFSecReviewProcessPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewProcessPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFSecReviewProcessFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFSecReviewProcessPagedResponseToJSON(value?: CRSFSecReviewProcessPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFSecReviewProcessToJSON)),
        'total': value.total,
    };
}

